module.exports = new __parcel__URL__("brickstuff.a675589e.avif").toString();